import React, { useState } from 'react'
import { i18n } from 'core/i18n';
import PropTypes from 'prop-types'

import { recordLink } from 'utilities/tagging'

import {
    DEFERRAL_DEPOSIT_MODAL_CONDITIONS_CATEGORY_EVENT,
    DEFERRAL_DEPOSIT_MODAL_CONDITIONS_ACTION_EVENT,
    DEFERRAL_DEPOSIT_MODAL_CONDITIONS_SHOW_MORE_TAG_EVENT,
    DEFERRAL_DEPOSIT_MODAL_CONDITIONS_SHOW_LESS_TAG_EVENT
} from 'constants/tagging';


const CONTACT_CENTER_POE_KEYS = {
    seeMore: 'contractsView-contractsView_ccDepositConditionSeeMore',
    hideDetails: 'contractsView-contractsView_ccDepositConditionHideDetails',
}

const WEB_POE_KEYS = {
    seeMore: 'contractsView-contractsView_depositConditionSeeMore',
    hideDetails: 'contractsView-contractsView_depositConditionHideDetails',
}

export const DepositInterveners = ({ role = '', interveners = '' }) => {
    const [showFullHolders, setShowFullHolders] = useState(false)
    const { FormattedText } = i18n

    const maxListLength = 5
    const intervenersLenght = interveners.length > maxListLength

    const poeKeys = __CONTACT_CENTER__
        ? CONTACT_CENTER_POE_KEYS
        : WEB_POE_KEYS

    const handleShowFullHolders = () => {
        const tagEvent = !showFullHolders
            ? DEFERRAL_DEPOSIT_MODAL_CONDITIONS_SHOW_MORE_TAG_EVENT
            : DEFERRAL_DEPOSIT_MODAL_CONDITIONS_SHOW_LESS_TAG_EVENT

        recordLink(DEFERRAL_DEPOSIT_MODAL_CONDITIONS_CATEGORY_EVENT, DEFERRAL_DEPOSIT_MODAL_CONDITIONS_ACTION_EVENT, tagEvent)
        setShowFullHolders(!showFullHolders)
    }

    const showHolders = () => {
        return (intervenersLenght && !showFullHolders)
            ? interveners.slice(0,maxListLength)
            : interveners
    }

    return (
        <div className="deposit-renovation-info__subitem">
            <FormattedText value={role} />
            <p className="deposit-renovation-info__subitem__value">
                {showHolders().join(', ')}
            </p>
            {
                intervenersLenght && (
                    <button onClick={handleShowFullHolders}>
                        {showFullHolders
                            ? <FormattedText value={poeKeys.hideDetails} />
                            : <FormattedText value={poeKeys.seeMore} />
                        }
                    </button>
                )
            }
        </div>
    )
}

DepositInterveners.propTypes = {
    role: PropTypes.string,
    interveners: PropTypes.string,
};